import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../services/api';
import backgroundImage from '../assets/images/login-bg.jpg';

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [fadeIn, setFadeIn] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.height = '100vh';
    document.documentElement.style.height = '100vh';
    setFadeIn(true);
  }, []);

  // Debounced showPassword logic
  // useEffect(() => {
  //   const delay = setTimeout(() => {
  //     setShowPassword(username.length >= 4);
  //   }, 600);
  //   return () => clearTimeout(delay);
  // }, [username]);

  // Debounced showButton logic
  // useEffect(() => {
  //   const delay = setTimeout(() => {
  //     setShowButton(username.length >= 4 && password.length >= 4);
  //   }, 600);
  //   return () => clearTimeout(delay);
  // }, [username, password]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await loginUser(username, password);
    if (res.success) {
      localStorage.setItem('authToken', res.data.access || 'dummy-token');
      window.location.href = '/home';
    } else {
      setError(res.message);
    }
  };

  return (
    <div style={{ ...styles.page, backgroundImage: `url(${backgroundImage})` }}>
      <div style={styles.overlay}></div>
      <div style={styles.formWrapper}>
        <form
          onSubmit={handleSubmit}
          style={{
            ...styles.form,
            opacity: fadeIn ? 1 : 0,
            transform: fadeIn ? 'translateY(0)' : 'translateY(30px)',
            transition: 'all 0.6s ease'
          }}
        >
          <h2 style={styles.heading}>Welcome Back</h2>

          <input
            type="text"
            placeholder="Enter Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            style={styles.input}
            required
          />

          {/* Password Field */}
          {/* {showPassword && ( */}
            <input
              type="password"
              placeholder="Enter Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={styles.input}
              required
            />
          {/* )} */}


          {/* {showButton && ( */}
            <button type="submit" style={styles.button}>Login</button>
          {/* )} */}

          {error && <p style={styles.error}>{error}</p>}
        </form>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden'
  },
  overlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.3)',
    zIndex: 1
  },
  formWrapper: {
    zIndex: 2,
    width: '100%',
    maxWidth: '700px',
    padding: '20px',
    boxSizing: 'border-box'
  },
  form: {
    background: 'rgba(255, 255, 255, 0.12)',
    padding: '40px 30px',
    borderRadius: '15px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    color: '#fff',
    width: '100%',
    maxWidth: '700px',
    minHeight: '460px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'
  },
  heading: {
    marginBottom: '25px',
    fontSize: '36px',
    fontWeight: 'bold',
    color: '#5b0412',
    textShadow: '1px 1px 4px rgba(0,0,0,0.4)'
  },
  input: {
    width: '80%',
    padding: '16px',
    margin: '12px 0',
    borderRadius: '8px',
    border: 'none',
    outline: 'none',
    fontSize: '22px',
    fontWeight:'600',
    backgroundColor: '#fff',
    color: '#333',
    boxShadow: 'inset 0 0 5px rgba(0,0,0,0.2)',
    transition: 'all 0.3s ease'
  },
  button: {
    width: '80%',
    padding: '12px',
    backgroundColor: '#1e90ff',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '22px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    marginTop: '10px',
    boxShadow: '0 4px 10px rgba(30,144,255,0.4)',
    transition: 'all 0.3s ease'
  },
  error: {
    marginTop: '15px',
    color: '#ff4d4d',
    fontWeight: 'bold'
  }
};

export default Login;
